import { render, staticRenderFns } from "./SuggestedAutopay.vue?vue&type=template&id=666248e2&scoped=true&"
import script from "./SuggestedAutopay.vue?vue&type=script&lang=ts&"
export * from "./SuggestedAutopay.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedAutopay.vue?vue&type=style&index=0&id=666248e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666248e2",
  null
  
)

export default component.exports